import { render, staticRenderFns } from "./GpsRankingPlayerParts.vue?vue&type=template&id=0aa9028c&scoped=true"
import script from "./GpsRankingPlayerParts.vue?vue&type=script&lang=ts"
export * from "./GpsRankingPlayerParts.vue?vue&type=script&lang=ts"
import style0 from "./GpsRankingPlayerParts.vue?vue&type=style&index=0&id=0aa9028c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa9028c",
  null
  
)

export default component.exports